import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        path: '/404',
        alias: ['/', '/:type?', '/:type?/'],
        name: '404',
        component: () => import('@views/404.vue'),
        sensitive: true,
        meta: {
            visibility: 'all'
        }
    },
    {
        path: '/500',
        name: '500',
        component: () => import('@views/500.vue'),
        sensitive: true,
        meta: {
            visibility: 'all'
        }
    },
    {
        path: '/:type/changePassword',
        name: 'ChangePassword',
        component: () => import('@views/ChangePassword.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: 'all'
        }
    },
    {
        path: '/:type/firstLoginPassword',
        name: 'FirstLoginPassword',
        component: () => import('@views/FirstLoginPassword.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: 'all'
        }
    },
    {
        path: '/:type/home',
        name: 'Home',
        component: () => import('@views/Home.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: 'all'
        }
    },
    {
        path: '/:type/login',
        name: 'Login',
        component: () => import('@views/Login.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresNoAuthGuard: true,
            visibility: 'all'
        }
    },
    {
        path: '/:type/trdLogin',
        name: 'trdLogin',
        component: () => import('@views/3rdLogin.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresNoAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/admin',
        name: 'Admin',
        component: () => import('@views/admin/admin/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/adminCreate',
        name: 'AdminCreate',
        component: () => import('@views/admin/admin/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/adminEdit',
        name: 'AdminEdit',
        component: () => import('@views/admin/admin/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/adminProfile',
        name: 'AdminProfile',
        component: () => import('@views/admin/profile/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/adminProfileCreate',
        name: 'AdminProfileCreate',
        component: () => import('@views/admin/profile/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm'],
            selRefresh: true
        }
    },
    {
        path: '/:type/adminProfileEdit',
        name: 'AdminProfileEdit',
        component: () => import('@views/admin/profile/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm'],
            selRefresh: true
        }
    },
    {
        path: '/:type/admMyProfile',
        name: 'AdminMyProfile',
        component: () => import('@views/admin/myProfile/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/auditLog',
        name: 'AuditLog',
        component: () => import('@views/admin/audit/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/module',
        name: 'Module',
        component: () => import('@views/admin/module/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/moduleCreate',
        name: 'ModuleCreate',
        component: () => import('@views/admin/module/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm'],
            selRefresh: true
        }
    },
    {
        path: '/:type/moduleEdit',
        name: 'ModuleEdit',
        component: () => import('@views/admin/module/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm'],
            selRefresh: true
        }
    },
    {
        path: '/:type/site',
        name: 'Site',
        component: () => import('@views/admin/site/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        },
        children: [
            // {
            //     path: 'create',
            //     name: 'SiteCreate',
            //     component: () => import('@views/admin/site/Create.vue'),
            //     sensitive: true,
            //     meta: {
            //         requiresType: true,
            //         requiresAuthGuard: true
            //     }
            // }
            // {
            //     path: 'edit',
            //     name: 'Site.Edit',
            //     component: () => import('@views/admin/site/Edit.vue'),
            //     sensitive: true,
            //     meta: {
            //         requiresType: true,
            //         requiresAuthGuard: true
            //     }
            // },
        ]
    },
    {
        path: '/:type/siteCreate',
        name: 'SiteCreate',
        component: () => import('@views/admin/site/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/siteEdit',
        name: 'SiteEdit',
        component: () => import('@views/admin/site/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/siteGroup',
        name: 'SiteGroup',
        component: () => import('@views/admin/siteGroup/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/siteGroupCreate',
        name: 'SiteGroupCreate',
        component: () => import('@views/admin/siteGroup/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm'],
            selRefresh: true
        }
    },
    {
        path: '/:type/siteGroupEdit',
        name: 'SiteGroupEdit',
        component: () => import('@views/admin/siteGroup/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm'],
            selRefresh: true
        }
    },
    {
        path: '/:type/adminTheme',
        name: 'AdminTheme',
        component: () => import('@views/admin/theme/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm']
        }
    },
    {
        path: '/:type/adminThemeCreate',
        name: 'AdminThemeCreate',
        component: () => import('@views/admin/theme/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm'],
            selRefresh: true
        }
    },
    {
        path: '/:type/adminThemeEdit',
        name: 'AdminThemeEdit',
        component: () => import('@views/admin/theme/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['adm'],
            selRefresh: true
        }
    },

    {
        path: '/:type/stgAffiliate',
        name: 'SiteGroupAffiliate',
        component: () => import('@views/siteGroup/affiliate/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgAffiliateCreate',
        name: 'SiteGroupAffiliateCreate',
        component: () => import('@views/siteGroup/affiliate/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgAffiliateEdit',
        name: 'SiteGroupAffiliateEdit',
        component: () => import('@views/siteGroup/affiliate/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgAffiliateUser',
        name: 'SiteGroupAffiliateUser',
        component: () => import('@views/siteGroup/affiliate/AffiliateUsers.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgCampaign',
        name: 'SiteGroupCampaign',
        component: () => import('@views/siteGroup/campaign/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgCampaignCreate',
        name: 'SiteGroupCampaignCreate',
        component: () => import('@views/siteGroup/campaign/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgCampaignEdit',
        name: 'SiteGroupCampaignEdit',
        component: () => import('@views/siteGroup/campaign/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgCampaignPerformance',
        name: 'SiteGroupCampaignPerformance',
        component: () => import('@views/siteGroup/campaignPerformance/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgCurrencyRate',
        name: 'SiteGroupCurrencyRate',
        component: () => import('@views/siteGroup/site/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgCurrencyRateEdit',
        name: 'SiteGroupCurrencyRateEdit',
        component: () => import('@views/siteGroup/site/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgDomain',
        name: 'SiteGroupDomain',
        component: () => import('@views/siteGroup/domain/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgDomainCreate',
        name: 'SiteGroupDomainCreate',
        component: () => import('@views/siteGroup/domain/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgDomainEdit',
        name: 'SiteGroupDomainEdit',
        component: () => import('@views/siteGroup/domain/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgMaterial',
        name: 'SiteGroupMaterial',
        component: () => import('@views/siteGroup/material/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgMaterialCreate',
        name: 'SiteGroupMaterialCreate',
        component: () => import('@views/siteGroup/material/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgMaterialEdit',
        name: 'SiteGroupMaterialEdit',
        component: () => import('@views/siteGroup/material/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgMember',
        name: 'SiteGroupMember',
        component: () => import('@views/siteGroup/member/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgMicrosite',
        name: 'SiteGroupMicrosite',
        component: () => import('@views/siteGroup/microsite/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgMicrositeCreate',
        name: 'SiteGroupMicrositeCreate',
        component: () => import('@views/siteGroup/microsite/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgMicrositeEdit',
        name: 'SiteGroupMicrositeEdit',
        component: () => import('@views/siteGroup/microsite/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgMyProfile',
        name: 'SiteGroupMyProfile',
        component: () => import('@views/siteGroup/myProfile/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgPostback',
        name: 'SiteGroupPostback',
        component: () => import('@views/siteGroup/postback/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgPostbackCreate',
        name: 'SiteGroupPostbackCreate',
        component: () => import('@views/siteGroup/postback/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgPostbackEdit',
        name: 'SiteGroupPostbackEdit',
        component: () => import('@views/siteGroup/postback/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgProfile',
        name: 'SiteGroupProfile',
        component: () => import('@views/siteGroup/profile/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgProfileCreate',
        name: 'SiteGroupProfileCreate',
        component: () => import('@views/siteGroup/profile/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgProfileEdit',
        name: 'SiteGroupProfileEdit',
        component: () => import('@views/siteGroup/profile/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg'],
            selRefresh: true
        }
    },
    {
        path: '/:type/stgRegistration',
        name: 'SiteGroupRegistration',
        component: () => import('@views/siteGroup/registration/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgRegistrationEdit',
        name: 'SiteGroupRegistrationEdit',
        component: () => import('@views/siteGroup/registration/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgRptFTD',
        name: 'SiteGroupReportFTD',
        component: () => import('@views/siteGroup/report/ftd/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgRptTransaction',
        name: 'SiteGroupReportTransaction',
        component: () => import('@views/siteGroup/report/transaction/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgRptWinLose',
        name: 'SiteGroupReportWinLose',
        component: () => import('@views/siteGroup/report/winlose/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgRptGameType',
        name: 'SiteGroupReportGameType',
        component: () => import('@views/siteGroup/report/gameType/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgRptCampaign',
        name: 'SiteGroupReportCampaign',
        component: () => import('@views/siteGroup/report/campaign/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgRptCommission',
        name: 'SiteGroupReportCommission',
        component: () => import('@views/siteGroup/report/commission/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgSubAffiliate',
        name: 'SiteGroupSubAffiliate',
        component: () => import('@views/siteGroup/subAffiliate/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgRptSubAffiliate',
        name: 'SiteGroupSubAffiliateReport',
        component: () => import('@views/siteGroup/report/subAffiliate/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgTheme',
        name: 'SiteGroupTheme',
        component: () => import('@views/siteGroup/theme/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgThemeEdit',
        name: 'SiteGroupThemeEdit',
        component: () => import('@views/siteGroup/theme/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgThemeCustom',
        name: 'SiteGroupThemeCustom',
        component: () => import('@views/siteGroup/themeCustom/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgThemeCustomCreate',
        name: 'SiteGroupThemeCustomCreate',
        component: () => import('@views/siteGroup/themeCustom/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgThemeCustomEdit',
        name: 'SiteGroupThemeCustomEdit',
        component: () => import('@views/siteGroup/themeCustom/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgTracking',
        name: 'SiteGroupTracking',
        component: () => import('@views/siteGroup/tracking/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgTrackingCreate',
        name: 'SiteGroupTrackingCreate',
        component: () => import('@views/siteGroup/tracking/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgTrackingEdit',
        name: 'SiteGroupTrackingEdit',
        component: () => import('@views/siteGroup/tracking/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgUser',
        name: 'SiteGroupUser',
        component: () => import('@views/siteGroup/user/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgUserCreate',
        name: 'SiteGroupUserCreate',
        component: () => import('@views/siteGroup/user/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },
    {
        path: '/:type/stgUserEdit',
        name: 'SiteGroupUserEdit',
        component: () => import('@views/siteGroup/user/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['stg']
        }
    },

    {
        path: '/:type/aflCampaign',
        name: 'AffiliateCampaign',
        component: () => import('@views/affiliate/campaign/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflCampaignCreate',
        name: 'AffiliateCampaignCreate',
        component: () => import('@views/affiliate/campaign/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl'],
            selRefresh: true
        }
    },
    {
        path: '/:type/aflCampaignEdit',
        name: 'AffiliateCampaignEdit',
        component: () => import('@views/affiliate/campaign/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl'],
            selRefresh: true
        }
    },
    {
        path: '/:type/aflCampaignMember',
        name: 'AffiliateCampaignMember',
        component: () => import('@views/affiliate/campaign/ViewMember.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflCampaignPerformance',
        name: 'AffiliateCampaignPerformance',
        component: () => import('@views/affiliate/campaignPerformance/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflMaterial',
        name: 'AffiliateMaterial',
        component: () => import('@views/affiliate/material/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    // {
    //     path: '/:type/aflDomain',
    //     name: 'AffiliateDomain',
    //     component: () => import('@views/affiliate/domain/List.vue'),
    //     sensitive: true,
    //     meta: {
    //         requiresType: true,
    //         requiresAuthGuard: true,
    //         visibility: ['afl']
    //     }
    // },
    // {
    //     path: '/:type/aflDomainCreate',
    //     name: 'AffiliateDomainCreate',
    //     component: () => import('@views/affiliate/domain/Create.vue'),
    //     sensitive: true,
    //     meta: {
    //         requiresType: true,
    //         requiresAuthGuard: true,
    //         visibility: ['afl']
    //     }
    // },
    // {
    //     path: '/:type/aflDomainEdit',
    //     name: 'AffiliateDomainEdit',
    //     component: () => import('@views/affiliate/domain/Edit.vue'),
    //     sensitive: true,
    //     meta: {
    //         requiresType: true,
    //         requiresAuthGuard: true,
    //         visibility: ['afl']
    //     }
    // },
    {
        path: '/:type/aflMember',
        name: 'AffiliateMember',
        component: () => import('@views/affiliate/member/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflMemberCampaign',
        name: 'AffiliateMemberCampaign',
        component: () => import('@views/affiliate/member/ViewCampaign.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflMicrosite',
        name: 'AffiliateMicrosite',
        component: () => import('@views/affiliate/microsite/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflMicrositeCreate',
        name: 'AffiliateMicrositeCreate',
        component: () => import('@views/affiliate/microsite/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflMicrositeEdit',
        name: 'AffiliateMicrositeEdit',
        component: () => import('@views/affiliate/microsite/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflMyProfile',
        name: 'AffiliateMyProfile',
        component: () => import('@views/affiliate/myProfile/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflPostback',
        name: 'AffiliatePostback',
        component: () => import('@views/affiliate/postback/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflPostbackCreate',
        name: 'AffiliatePostbackCreate',
        component: () => import('@views/affiliate/postback/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflPostbackEdit',
        name: 'AffiliatePostbackEdit',
        component: () => import('@views/affiliate/postback/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflProfile',
        name: 'AffiliateProfile',
        component: () => import('@views/affiliate/profile/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflProfileCreate',
        name: 'AffiliateProfileCreate',
        component: () => import('@views/affiliate/profile/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl'],
            selRefresh: true
        }
    },
    {
        path: '/:type/aflProfileEdit',
        name: 'AffiliateProfileEdit',
        component: () => import('@views/affiliate/profile/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl'],
            selRefresh: true
        }
    },
    {
        path: '/:type/aflRptFTD',
        name: 'AffiliateReportFTD',
        component: () => import('@views/affiliate/report/ftd/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflRptTransaction',
        name: 'AffiliateReportTransaction',
        component: () => import('@views/affiliate/report/transaction/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflRptWinLose',
        name: 'AffiliateReportWinLose',
        component: () => import('@views/affiliate/report/winlose/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflRptGameType',
        name: 'AffiliateReportGameType',
        component: () => import('@views/affiliate/report/gameType/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflRptCampaign',
        name: 'AffiliateReportCampaign',
        component: () => import('@views/affiliate/report/campaign/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflRptCommission',
        name: 'AffiliateReportCommission',
        component: () => import('@views/affiliate/report/commission/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflSubAffiliate',
        name: 'AffiliateSubAffiliate',
        component: () => import('@views/affiliate/subAffiliate/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflSubAffiliateEdit',
        name: 'AffiliateSubAffiliateEdit',
        component: () => import('@views/affiliate/subAffiliate/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflRptSubAffiliate',
        name: 'AffiliateSubAffiliateReport',
        component: () => import('@views/affiliate/report/subAffiliate/Report.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflTheme',
        name: 'AffiliateTheme',
        component: () => import('@views/affiliate/theme/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflThemeEdit',
        name: 'AffiliateThemeEdit',
        component: () => import('@views/affiliate/theme/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflUser',
        name: 'AffiliateUser',
        component: () => import('@views/affiliate/user/List.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflUserCreate',
        name: 'AffiliateUserCreate',
        component: () => import('@views/affiliate/user/Create.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    },
    {
        path: '/:type/aflUserEdit',
        name: 'AffiliateUserEdit',
        component: () => import('@views/affiliate/user/Edit.vue'),
        sensitive: true,
        meta: {
            requiresType: true,
            requiresAuthGuard: true,
            visibility: ['afl']
        }
    }
];

export default routes;
